import { useEffect, useState } from 'react';
import { FaBars, FaShoppingCart, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
// import cv from '../images/cv1-2-5.pdf';
import menu from '../images/mn menu.pdf';
import logo from '../logos/moon logo creative.png';
import '../style/Header.css';
import { getCart, getCartItemCount, getCartTotal, removeFromCart } from './cartUtils';


const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [cart, setCart] = useState([]);
  const navigate = useNavigate()

  // Track cart items count and data
  useEffect(() => {
    const updateCartData = () => {
      setCart(getCart());
      setCartItemCount(getCartItemCount());
    };
    
    // Initial data
    updateCartData();
    
    // Listen for cart updates
    window.addEventListener('cartUpdated', updateCartData);
    
    return () => {
      window.removeEventListener('cartUpdated', updateCartData);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
    // Close mobile menu when opening cart
    if (!isCartOpen) {
      setIsMobileMenuOpen(false);
    }
  };

  const closeCart = () => {
    setIsCartOpen(false);
  };

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    
    if (targetId === '#home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  const total = getCartTotal();

  // CartSidebar component integrated
  const CartSidebar = () => {
    if (!isCartOpen) return null;

    return (
      <div className="cart-sidebar-overlay" onClick={closeCart}>
        <div className="cart-sidebar" onClick={(e) => e.stopPropagation()}>
          <div className="cart-header">
            <h3>🛒 سلة التسوق ({cart.length} منتج)</h3>
            <button onClick={closeCart} className="close-btn">
              <FaTimes />
            </button>
          </div>
          
          <div className="cart-items">
            {cart.length === 0 ? (
              <p className="empty-cart-message">السلة فارغة</p>
            ) : (
              cart.map(item => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} width="50" height="50" />
                  <div className="item-info">
                    <h5>{item.name}</h5>
                    <p>{item.price} جنيه × {item.quantity}</p>
                    <span className="item-total">{item.price * item.quantity} جنيه</span>
                  </div>
                  <button 
                    onClick={() => removeFromCart(item.id)}
                    className="remove-item-btn"
                    title="إزالة من السلة"
                  >
                    🗑️
                  </button>
                </div>
              ))
            )}
          </div>
          
          {cart.length > 0 && (
            <button 
              className="checkout-btn"
              onClick={() => {
                closeCart();
                navigate('/purchase'); // Add this navigation
              }}
            >
              ➡️ إتمام الشراء
            </button>
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      <header className="coffee-header">
        <div className="header-container">
          <div className='logo'>
            <a href="#" target='blank' rel="noopener noreferrer">
              <img src={logo} alt="Moon Logo"/>
            </a>
          </div>
          
          {/* Navigation */}
          <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><a href="#home" onClick={(e) => handleSmoothScroll(e, '#home')}>الرئيسية</a></li>
              <li><a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')}>معلومات التواصل</a></li>
              <li><a href={menu} target='blank' rel="noopener noreferrer">القائمة</a></li>
              {/* <li><a href={cv} target='blank' rel="noopener noreferrer">شهاداتي</a></li> */}
              <li>
                <button className="cart-btn" onClick={toggleCart}>
                  <FaShoppingCart />
                  {cartItemCount > 0 && (
                    <span className="cart-badge">{cartItemCount}</span>
                  )}
                </button>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {/* Integrated Cart Sidebar */}
      <CartSidebar />
    </>
  );
};

export default Header;